export const SUBSCRIPTION_STORAGE_KEY = 'lotnik360_subscription_plan';

export const PLANS = {
  free: {
    id: 'free',
    label: 'Free',
    features: {
      panel: true,
      pigeons: true,
      pedigree: false,
      pairing: false,
      flights: false,
      simulator: false,
      riskAnalysis: false,
    },
  },
  basic: {
    id: 'basic',
    label: 'Basic',
    features: {
      panel: true,
      pigeons: true,
      pedigree: true,
      pairing: true,
      flights: true,
      simulator: false,
      riskAnalysis: false,
    },
  },
  standard: {
    id: 'standard',
    label: 'Standard',
    features: {
      panel: true,
      pigeons: true,
      pedigree: true,
      pairing: true,
      flights: true,
      simulator: true,
      riskAnalysis: true,
    },
  },
  premium: {
    id: 'premium',
    label: 'Premium',
    features: {
      panel: true,
      pigeons: true,
      pedigree: true,
      pairing: true,
      flights: true,
      simulator: true,
      riskAnalysis: true,
    },
  },
};

export const DEFAULT_PLAN_ID = 'free';

export function getPlanById(planId) {
  return PLANS[planId] || PLANS[DEFAULT_PLAN_ID];
}
